import React, { useEffect, useState } from 'react';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@material-ui/core";

import AppInput from "../../../../components/Input/AppInput";
import AppButton from "../../../../components/CustomButtons/AppButton";
import { fetchAdminUserDetail, reduceUpdateAdminUser } from "../../../../store/slices/admin";
import { getAuthInfo } from 'store/slices/auth';
import { SYSTEM_ROLE } from 'config/AppConfig';
import { fetchCompanyUserDetail } from 'store/slices/companyUser';
import { reduceUpdateCompanyUser } from 'store/slices/companyUser';
import AppConfig from "config/AppConfig";

const { PATTERNS } = AppConfig;

const AdminUserDetailForm = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { id } = useParams();
    const dispatch = useDispatch();
    const user = useSelector(getAuthInfo);

    const [submitting, setSubmitting] = useState(false);
    const [initializeData, setInitializeData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        permissions: ''
    })
    const _submit = (data) => {
        let request = {
            firstName: data.firstName,
            lastName: data.lastName,
            permissions: initializeData.permissions,
            id
        }
        if (user.role === SYSTEM_ROLE.COMPANY) {
            request.companyId = user.companyId;
        }
        setSubmitting(true);
        dispatch(user.role === SYSTEM_ROLE.COMPANY ? reduceUpdateCompanyUser(request) : reduceUpdateAdminUser(request))
            .then(() => {
                setSubmitting(false);
                _loadData();
            })
    }

    const _loadData = () => {
        let request = { id: id };
        if (user.role === SYSTEM_ROLE.COMPANY) {
            request.companyId = user.companyId;
        }
        dispatch(user.role === SYSTEM_ROLE.COMPANY ? fetchCompanyUserDetail(request) : fetchAdminUserDetail({ id }))
            .then(({ payload }) => {
                if (payload) {
                    setInitializeData({
                        ...initializeData,
                        firstName: payload.firstName || '',
                        lastName: payload.lastName || '',
                        email: payload.email || '',
                        permissions: payload.permissions || payload.adminPermissions
                    });
                }
            })
    }

    useEffect(() => {
        _loadData();
    }, [])

    return (
        <Formik
            initialValues={initializeData}
            validationSchema={Yup.object().shape({
                firstName: Yup.string().required('validation.first_name.required').max(64, "validation.max_length_64")
                // .matches(PATTERNS.XSS_PATTERN, 'validation.xssPatterns')
                .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces'),
                lastName: Yup.string().required('validation.first_name.required').max(64, "validation.max_length_64")
                // .matches(PATTERNS.XSS_PATTERN, 'validation.xssPatterns')
                .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces'),
                email: Yup.string().trim()
                .required('validation.email.required')
                .email('validation.email.invalid')
                .max(255, { message: 'validation.max_length', value: 255})
                .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces')
            })}
            onSubmit={_submit}
            enableReinitialize
        >
            {({ handleSubmit }) => (
                <>
                    <Field
                        component={AppInput}
                        name="email"
                        label={t('label.email')}
                        required
                        disabled
                    />
                    <Field
                        component={AppInput}
                        name="firstName"
                        label={t('label.first_name')}
                        required
                    />
                    <Field
                        component={AppInput}
                        name="lastName"
                        label={t('label.last_name')}
                        required
                    />
                    <Box display="flex" justifyContent="flex-end" alignItems="center" mt={3}>
                        <AppButton
                            label={t('button.back')}
                            onClick={() => history.goBack()}
                            mode="outlined"
                            style={{
                                marginRight: '1rem'
                            }}
                        />
                        <AppButton
                            label={t('button.save')}
                            onClick={handleSubmit}
                            isLoading={submitting}
                            disabled={submitting}
                        />
                    </Box>
                </>
            )}
        </Formik>
    )
}

AdminUserDetailForm.propTypes = {
}

export default AdminUserDetailForm;
